import { render, staticRenderFns } from "./DescriptionModal.vue?vue&type=template&id=78d01660&scoped=true"
import script from "./DescriptionModal.vue?vue&type=script&lang=js"
export * from "./DescriptionModal.vue?vue&type=script&lang=js"
import style0 from "./DescriptionModal.vue?vue&type=style&index=0&id=78d01660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d01660",
  null
  
)

export default component.exports